var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.client != null)?_c('CloudFiles',{attrs:{"path":_vm.client.id,"partyId":_vm.client.id}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }